import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import Header from './Header';
import Footer from './Footer';
import FloatingCart from '@/components/cart/FloatingCart';

export default function Layout() {
  const restore = useAuthStore((s) => s.restore);
  const initialized = useAuthStore((s) => s.initialized);

  useEffect(() => {
    if (!initialized) {
      void restore();
    }
  }, [initialized, restore]);

  return (
    <div className="app-shell">
      <Header />
      <main className="main">
        <div className="container">
          <Outlet />
        </div>
      </main>
      <Footer />
      <FloatingCart />
    </div>
  );
}
